<template>
  <el-form :model="form" label-width="auto" inline class="list-filter" :style="wstyle">
    <div class="list-filter-formitem-wrapper" :style="itemStyle" v-for="(item, index) in _formList" :key="index">
      <label>{{ item.label }}</label>
      <!-- input -->
      <div class="list-filter-formitem-wrap" v-if="item.type == 'input'">
        <el-input v-model="form[item.field]" :placeholder="item.placeholder" :style="item.style" clearable />
      </div>

      <!-- select -->
      <div class="list-filter-formitem-wrap" v-if="item.type == 'select'">
        <el-select v-model="form[item.field]" :multiple="item.multiple" :placeholder="item.placeholder" :style="item.style" clearable :collapse-tags="item.collapseTags">
          <el-option v-for="(itm, idx) in item.options" :label="itm.label" :value="itm.value" :key="idx" />
        </el-select>
      </div>

      <!-- select-search-form-remote -->
      <div class="list-filter-formitem-wrap" v-if="item.type == 'select-search'">
        <el-select
          popper-class="list-filter-formitem-select-search"
          v-model="form[item.field]"
          :multiple="item.multiple"
          :placeholder="item.placeholder"
          :style="item.style"
          clearable
          remote
          reserve-keyword
          filterable
          remote-show-suffix
          :remote-method="query => selectSearchFormRemoteAction(query, item)"
        >
          <template v-if="[ 'porCode', 'pdlCode' ].includes(item.field)">
            <el-option v-for="(itm, idx) in selectSearchFormRemoteOptions" :label="itm.label" :value="itm.value" :key="idx">
              <template #default>
                <div class="list-filter-formitem-porpdl">
                  <div class="porpdl-label">{{ itm?.label }},{{ itm?.countryVO?.twoCode }}</div>
                  <div class="porpdl-content">
                    <span class="country">{{itm?.englishName}}</span>
                    <span class="wucode">{{ itm?.chineseName }}({{itm?.unCode}})</span>
                  </div>
                </div>
              </template>
            </el-option>
          </template>
          <template v-else>
            <el-option v-for="(itm, idx) in selectSearchFormRemoteOptions" :label="itm.label" :value="itm.value" :key="idx" />
          </template>
        </el-select>
      </div>

      <!-- userselect -->
      <div class="list-filter-formitem-wrap" v-if="item.type == 'userselect'">
        <el-select
          v-model="form[item.field]"
          :multiple="item.multiple"
          filterable
          remote
          reserve-keyword
          :placeholder="item.placeholder || '请选择'"
          remote-show-suffix
          :remote-method="userSelectAction"
          :loading="userSelectLoading"
        >
        <el-option v-for="item in userSelectOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      </div>

      <!-- datetimerange -->
      <div class="list-filter-formitem-wrap" v-if="item.type == 'datetimerange'">
        <el-date-picker
          v-model="form[item.field]"
          type="datetimerange"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :value-format="item?.valueFormat || 'YYYY-MM-DD HH:mm:ss'"
          :format="item?.format || 'YYYY-MM-DD HH:mm:ss'"
        />
      </div>
    </div>

    <!-- 按钮 -->
    <div class="list-filter-btns" v-if="showButton">
      <el-button type="primary" @click="searchHandle">查询</el-button>
      <el-button @click="resetHandle" style="height: 34px;">重置</el-button>
      <el-button @click="$emit('newadd')" :icon="Plus" type="primary" plain v-if="newadd">新增</el-button>
    </div>
  </el-form>
</template>

<script setup>
import {ref, watch, onMounted} from 'vue'
import { Delete, Edit, Plus } from '@element-plus/icons-vue'
import * as Request from '@/assets/request'

const form = ref({});

// eslint-disable-next-line no-undef
const props = defineProps({
  wstyle: {
    type: String,
    default: ''
  },
  itemStyle: {
    type: String,
    default: ''
  },
  formList: {
    type: Array,
    default: () => []
  },
  showButton: {
    type: Boolean,
    default: true
  },
  newadd: {
    type: Boolean,
    default: false
  },
  newaddConfig: {
    type: Object,
    default: null
  }
})

// eslint-disable-next-line no-undef
const emit = defineEmits([ 'search', 'change' ])

/**
 * 初始化
 */
const _formList = ref([])
const init = () => {
  console.log('props.formList-----',props.formList)
  _formList.value = props.formList
  if(props.formList?.length > 0) {
    props.formList.map(item => {
      form.value[item.field] = item.value;
    })
  }
}
onMounted(() => {
  init()
})
watch(() => props.formList, () => {
  init()
}, {
  deep: true
})

watch(() => form.value, () => {
  console.log('eeee', form.value)
  emit('change', form.value);
}, { deep: true });

// 重置
const resetHandle = () => {
  form.value = {}
  searchHandle();
}

// 查询
const searchHandle = () => {
  emit('search', form.value)
}

/**
 * 选择用户
 */
const userSelectOptions = ref([])
const userSelectLoading = ref(false);
const userSelectAction = async (query) => {
  if(!query) {
    userSelectOptions.value = [];
    return;
  }

  userSelectLoading.value = true;
  const result = await Request.post({
    url: '/40002/rms/user/search',
    data: { keyWord: query }
  });
  userSelectLoading.value = false;
  if(result?.code != 200) return;

  const _options = [];
  if(result?.data?.content?.length > 0) {
    result.data.content.map(item => {
      _options.push({ value: item?.id, label: item?.realName })
    })
  }
  userSelectOptions.value = _options;
}

/**
 * 远程搜索与选择
 */
const selectSearchFormRemoteOptions = ref([]);
const selectSearchFormRemoteAction = async (query, item) => {
  selectSearchFormRemoteOptions.value = [];

  if(!query) {
    return;
  }

  const result = await Request.post({
    url: item.remoteMethodUrl,
    data: {
      ...item.remoteMethodQuery,
      keyWord: query,
      keyword: query,
    }
  });
  if(result?.code != 200) return;

  if(result?.data?.content?.length > 0) {
    result.data.content.map(dataItem => {
      const res = item.optionItemFormat(dataItem)
      if(res) {
        selectSearchFormRemoteOptions.value.push(res)
      }
    })
  }
}

</script>

<style scoped lang="less">
  @import "index.less";
</style>
<style>
  .list-filter-formitem-select-search{
    display: block;
    .el-select-dropdown__item{
      height: auto!important;
      line-height: auto!important;
      padding: 0 12px!important;
    }

    .list-filter-formitem-porpdl {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 8px 0;

      >.porpdl-label {
        font-family: Noto Sans SC;
        font-weight: 400;
        font-size: 14px;
        color: #232326;
        display: flex;
        align-items: center;
        height: 17px;
      }

      >.porpdl-content {
        display: flex;
        gap: 6px;
        height: 14px;
        align-items: center;

        .country {
          font-family: Noto Sans SC;
          font-weight: 400;
          font-size: 10px;
          color: #4EBE41;
          border-radius: 2px;
          background-color: #F6FCF5;
          padding: 1px 4px;
          height: 100%;
          display: flex;
          align-items: center;
        }

        .wucode {
          font-family: Noto Sans SC;
          font-weight: 400;
          font-size: 12px;
          color: #B6B9BF;
          height: 100%;
          display: flex;
          align-items: center;
        }
      }
    }
  }
</style>